<template>
<v-app id="inspire">
  <v-main>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-form name="form" id="form-login" @submit.prevent="handleLogin">
            <v-card class="elevation-12">
              <v-toolbar color="primary" dark flat>
                <v-toolbar-title color="primary">Login</v-toolbar-title>
              </v-toolbar>
                <v-card-text>
                  <v-text-field label="Login" name="username" type="text" v-model="user.username" prepend-icon="mdi-account" />
                  <v-text-field id="password" label="Password" name="password" type="password" prepend-icon="mdi-lock" v-model="user.password" />
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn type="submit" color="primary">Login</v-btn>
                  <v-spacer />
                </v-card-actions>
            </v-card>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</v-app>
</template>

<script>
import User from '@/models/user.js';

export default {
  name: 'login',
  data() {
    return {
      user: new User('', ''),
      message: ''
    };
  },
  created() {
    if (this.loggedIn) {
      this.$router.push('/');
    }
  },
  methods: {
    handleLogin() {
      if (this.user.username && this.user.password) {
        this.$nprogress.start();
        this.$store.dispatch('login', this.user)
          .then(() => this.$router.push('/'),
          error => {
            if (error.status == 401)
              this.$msg.error("Usuário ou senha inválidos.")
            else
              this.$msg.error(error.message)
          })
          .finally(() => this.$nprogress.done());
      }
    }
  }
};
</script>
